import publicRoutes from "@/router/public.js";
import authenticatedRoutes from "@/router/authenticated.js";

export default publicRoutes.concat(authenticatedRoutes);